import { RouteConfig } from "vue-router";

export default Array<RouteConfig>(
	{
		path: ":id",
		name: "Employees-content",
		meta: {
			layout: "main"
		},
		props: true,
	}
);